import Notice from "../../../components/modals/notice/notice";

const NavNotice = () => {
  return <Notice />;
};

export default NavNotice;
